import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es difícil preparar esta comida? No tengo mucho tiempo.',
    a: "En absoluto. El método está diseñado para personas ocupadas. Con nuestro 'Recetario Express' (incluido como bono), puedes preparar comidas balanceadas en menos de 15 minutos, a veces más rápido que ir a la tienda por croquetas."
  }, {
    q: '¿Mi perro/gato es muy mayor, aún le sirve este método?',
    a: '¡Por supuesto! De hecho, los animales mayores son los que muestran cambios más dramáticos y rápidos. Una nutrición bio-apropiada alivia la carga en sus órganos y reduce la inflamación articular casi de inmediato.'
  }, {
    q: '¿Es más caro que comprar croquetas premium?',
    a: 'A corto plazo, el costo es similar al de unas croquetas de gama alta. A largo plazo, ahorrarás miles de dólares en facturas veterinarias, limpiezas dentales y medicamentos. Es una inversión en su salud.'
  }, {
    q: '¿Qué pasa si a mi mascota no le gusta?',
    a: "El método incluye técnicas específicas de transición para mascotas 'melindrosas'. Además, tienes nuestra garantía de 30 días. Si no logras la transición o no ves resultados, te devolvemos el 100% de tu dinero."
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Todo el contenido es 100% digital. Inmediatamente después de tu compra, recibirás un correo con acceso instantáneo a la plataforma donde podrás leer, descargar e imprimir todo el material desde cualquier dispositivo.'
  }];
  return <section className="py-24 bg-cream-light border-t border-sage-light/20" data-id="element-45">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center mb-16" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-48">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-49">
            Todo lo que necesitas saber antes de dar el paso.
          </p>
        </div>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, i) => <div key={i} className={`bg-white rounded-2xl border transition-all duration-300 ${openIndex === i ? 'border-sage shadow-md' : 'border-gray-100 shadow-sm hover:border-sage-light'}`} data-id="element-51">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-52">
                <span className="font-bold text-gray-900 pr-8" data-id="element-53">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-54" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-55">
                <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-56">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}